import { utils } from '@hh/global.js';
const { serializeForm } = utils;

if (!customElements.get('bis-form-wrapper')) {
  customElements.define(
    'bis-form-wrapper',
    class BISFormWrapper extends HTMLElement {
      constructor() {
        super();

        this.form?.addEventListener('submit', this.onSubmit.bind(this));
        this.error = this.querySelector('[data-error]');
        this.errorText = this.error.textContent;

        this.errorCheckbox = this.querySelector('[data-error-checkbox]');
        this.errorCheckboxText = this.errorCheckbox?.textContent;

        this.success = this.querySelector('[data-success]');
        this.successText = this.success.textContent;
      }

      onSubmit(event) {
        event.preventDefault();
        this.removeAttribute('error');
        this.removeAttribute('error-checkbox');
        const { Email, PhoneNumber, Sku, AlertCode } = JSON.parse(serializeForm(this.form));

        // Get SMS opt-in checkbox state
        const smsOptInCheckbox = this.form.querySelector('#bis-sms-optin');
        const smsOptedIn = smsOptInCheckbox?.checked || false;

        // If phone number is provided, checkbox must be checked
        if (PhoneNumber && !smsOptedIn) {
          this.setAttribute('error-checkbox', '');
          return; // Stop form submission if phone provided without opt-in
        }

        // Check if Email is empty (email is required)
        if (!Email) {
          this.setAttribute('error', '');
          return; // Stop form submission if email is blank
        }

        if (Email && Sku && AlertCode && _ltk?.Alerts) {
          // Always send both Email and PhoneNumber to Listrak
          // PhoneNumber will be empty string if not provided or not opted in
          const phoneToSend = (smsOptedIn && PhoneNumber) ? PhoneNumber : '';

          _ltk.Alerts.AddAlertWithIdentifiers({
            Identifiers: {
              Email: Email,
              PhoneNumber: phoneToSend,
            },
            Sku,
            AlertCode,
          });
          _ltk.Alerts.Submit();
          this.setAttribute('success', '');

          // Clear form fields after successful submission
          this.form.reset();

          setTimeout(() => {
            this.removeAttribute('success');
          }, 3000);
        } else if (!_ltk) {
          console.error('The _ltk object is not defined.');
        }
      }

      // watch for error attribute changes
      static get observedAttributes() {
        return ['error', 'success'];
      }

      // handle error attribute changes
      // eslint-disable-next-line no-unused-vars
      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'error') {
          // eslint-disable-next-line no-console
          this.refreshErrorText();
        } else if (name === 'success') {
          // eslint-disable-next-line no-console
          // console.log('TODO: handle success logic');

          this.refreshSuccessText();
        }
      }

      // This make sure that the screen reader reads the error message
      refreshErrorText() {
        if (this.error.textContent === '') return;
        this.error.textContent = '';
        this.error.textContent = this.errorText;
      }

      refreshSuccessText() {
        if (this.success.textContent === '') return;
        this.success.textContent = '';
        this.success.textContent = this.successText;
      }

      get form() {
        return this.querySelector('form') || '';
      }
    },
  );
}
